import classNames from 'classnames';

const computeStyle = (x, y, width, height) => {
    const left = x / width * 100;
    const right = y / height * 100;

    return {left: `${left}%`, top: `${right}%`};
};

const Pin = ({x, y, width, height, direction}) => (
    <span
        className={classNames('map-pin', 'map-pin-location', 'icon', `icon-pin-${direction}`)}
        style={computeStyle(x, y, width, height)}
    />
);

export default Pin;
